import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { selectGameId } from "features/gamestate/gameStateSlice";
import { GAMESTATE_ROUND_FINAL } from "features/gamestate/constants";
import Analytics from "analytics";
import { EVENTS } from "analytics/events";
import EditorToolbar from "./EditorToolbar";
import EditorBoard from "./EditorBoard";
import FinalRoundBoard from "./FinalRoundBoard";
import EditorPanel from "./EditorPanel";
import { clearPanelSelection } from "./editorSlice";
import "./roundEditor.css";

const RoundEditor = () => {
  const { round } = useParams();
  const gameId = useSelector(selectGameId);
  const dispatch = useDispatch();
  const isFinal = round === GAMESTATE_ROUND_FINAL;

  useEffect(() => {
    if (gameId && round) {
      Analytics.track(EVENTS.GAME_EDITOR_OPENED, { game_id: gameId, round });
    }
  }, [gameId, round]);

  // Changing rounds must drop any selection — otherwise the stale clue keeps the
  // board dimmed (spotlight active, nothing lit) and the old clue stays in the
  // panel. Also clears on entering/leaving the editor.
  useEffect(() => {
    dispatch(clearPanelSelection());
    return () => {
      dispatch(clearPanelSelection());
    };
  }, [round, dispatch]);

  return (
    <div className="re-root">
      <EditorToolbar round={round} />
      <div className="re-body">
        <div className="re-board-area">
          {isFinal ? <FinalRoundBoard /> : <EditorBoard round={round} />}
        </div>
        <EditorPanel round={round} isFinal={isFinal} />
      </div>
    </div>
  );
};

export default RoundEditor;
